import { Component } from '@angular/core';
import { EditFlightSearchComponent } from '../edit-flight-search/edit-flight-search.component';
import { LoginProfileComponent } from '../login-profile/login-profile.component';

@Component({
    selector: 'app-new-profile',
    templateUrl: './new-profile.component.html',
    styleUrls: ['./new-profile.component.scss'],
    imports: [EditFlightSearchComponent, LoginProfileComponent]
})
export class NewProfileComponent {

}
